import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import '../../../node_modules/echarts/map/js/world.js';
import '../../../node_modules/echarts/map/js/china.js';
import { chartMixins } from './chartMixins';
import { nameMap } from './world'; // echarts.registerTheme('tdTheme', tdTheme)

export default {
  name: 'maper',
  mixins: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (this.dom) {
        this.setOption(newVal);
      }
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      this.option = {
        tooltip: {
          //提示组件框 相关行为
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2,
          formatter: function formatter(params) {
            var value = params.value;

            if (value > 0) {
              return params.name + ': ' + value;
            } else {
              return params.name + ': ' + 0;
            }
          }
        },
        visualMap: [{
          show: true,
          dimension: 0,
          left: 10,
          bottom: 5,
          itemWidth: 12,
          min: 0,
          max: 19999,
          text: [],
          calculable: true,
          textStyle: {
            color: '#fff'
          },
          inRange: {
            color: ['#094b7a', '#ffba13']
          }
        }],
        series: [{
          geoIndex: 0,
          aspectScale: 0.75,
          //长宽比
          nameMap: localStorage.getItem('local') === 'zh-CN' ? nameMap : {},
          // 自定义名称映射
          type: 'map',
          mapType: 'world',
          roam: true,
          //是否开启鼠标缩放和平移漫游
          selectedMode: 'single',
          zoom: 1.2,
          scaleLimit: {
            min: 1,
            max: 8
          },
          label: {
            show: true,
            color: '#fff',
            emphasis: {
              show: true,
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#094b7a',
              borderColor: '#02cdde',
              label: {
                show: false
              },
              shadowColor: '#075e8b',
              shadowBlur: 1,
              opacity: 0.5
            },
            emphasis: {
              areaColor: '#05a7bd',
              emphasis: {
                label: {
                  show: true
                },
                color: '#fff'
              },
              shadowColor: '#085882'
            }
          },
          data: value
        }]
      };
      return this.option;
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    },

    /**
     * 初始化
     */
    init: function init() {
      var _this = this;

      this.dom = echarts.init(this.$refs.dom);
      this.dom.setOption(this.setParams(this.value));
      on(window, 'resize', this.resize);
      setTimeout(function () {
        _this.resize();
      });
      this.dom.on('click', function (param) {
        if (param.name === 'China') {
          _this.setOption();
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};